import React from 'react';

import { Icon, useTranslation } from '@testsigma/atoms';

import { DocumentURL } from '@utils/common';

const ConnectionFormHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center justify-between h-[60px]'>
      <div className='flex items-center'>
        <div className='ml-8 items-center my-4 mr-1 font-medium text-[18px] text-secondary-unique-600'>
          {t('metadata.connection.label')}
        </div>
        <DocumentURL path='/docs/salesforce-testing/introduction/'>
          <Icon
            name='help'
            toolTip={t('connection.help.tooltip')}
            className='flex items-center text-secondary-400 hover:text-secondary-500'
          />
        </DocumentURL>
      </div>
      <DocumentURL
        path='/docs/salesforce-testing/metadata-connections/'
        label='add-connection.info.link'
        className='mr-5 items-center my-4 text-sm'
      />
    </div>
  );
};

export { ConnectionFormHeader };
